export const DragTypes = {
  ITEM: 'item',
  TABLE: 'table',
  CHEQUE: 'cheque',
  TERMINAL: 'terminal',
};
